import { render, staticRenderFns } from "./arrow-to-bottom.vue?vue&type=template&id=44f2899b&"
import script from "./arrow-to-bottom.vue?vue&type=script&lang=js&"
export * from "./arrow-to-bottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports